const gameInfoEndpoint = "/info/game";
const channelInfoEndpoint = "/info/channel";
const propInfoEndpoint = "/info/prop";
const matchEndpoint = "/config/match";
const allXienEndpoint = "/info/xien";

const channelInfo = () => {
	return axios.get(channelInfoEndpoint);
}

const gameInfo = () => {
	return axios.get(gameInfoEndpoint);
}

const propInfo = () => {
	return axios.get(propInfoEndpoint);
}

const channelTodayInfo = () => {
	return axios.get(matchEndpoint);
}

const allXienChannelInfo = () => {
	return axios.get(allXienEndpoint)
}

export { channelInfo, gameInfo, propInfo, channelTodayInfo, allXienChannelInfo };